<div class="doc-preview">

  <div class="doc-preview__header">
    <div class="doc-preview__title">
       <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M6 2C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2H6Z" fill="#0078D4"/>
                    <path d="M14 2V7C14 7.55228 14.4477 8 15 8H20L14 2Z" fill="#5FACE3"/>
                    <rect x="7.5" y="10.2" width="5" height="1.6" rx="0.8" fill="#ffffff" opacity="0.9"/>
                    <rect x="7.5" y="13.4" width="9" height="1.6" rx="0.8" fill="#ffffff"/>
                    <rect x="7.5" y="16.6" width="9" height="1.6" rx="0.8" fill="#ffffff"/>
                  </svg>
      <span class="doc-preview__name" [title]="documentName">{{ documentName }}</span>
    </div>

    <div class="doc-preview__actions">
      <ng-container *ngIf="kind === 'image' && !loadError">
        <button type="button" class="doc-preview__icon-btn" (click)="zoomOut()" [disabled]="zoomLevel <= minZoom"
                aria-label="Zoom out" title="Zoom out">
          <i class="fa fa-search-minus" aria-hidden="true"></i>
        </button>
        <button type="button" class="doc-preview__zoom-label" (click)="resetZoom()" title="Reset zoom">{{ zoomPercent }}%</button>
        <button type="button" class="doc-preview__icon-btn" (click)="zoomIn()" [disabled]="zoomLevel >= maxZoom"
                aria-label="Zoom in" title="Zoom in">
          <i class="fa fa-search-plus" aria-hidden="true"></i>
        </button>
        <span class="doc-preview__divider" aria-hidden="true"></span>
      </ng-container>

      <button type="button" class="doc-preview__icon-btn" (click)="download()" [disabled]="!documentUrl || downloadInProgress"
              aria-label="Download document" title="Download">
        <i class="fa" [ngClass]="downloadInProgress ? 'fa-spinner fa-spin' : 'fa-download'" aria-hidden="true"></i>
      </button>
      <button type="button" class="doc-preview__icon-btn doc-preview__close" (click)="close()" aria-label="Close preview">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </div>
  </div>

  <div class="doc-preview__body">

    <!-- Loading -->
    <div class="doc-preview__state" *ngIf="loading && !loadError">
      <div class="doc-preview__spinner" aria-hidden="true"></div>
      <p class="doc-preview__state-subtitle">{{ loadingMessage }}</p>
    </div>

    <!-- Error -->
    <div class="doc-preview__state" *ngIf="loadError">
      <i class="fa fa-exclamation-triangle doc-preview__state-icon doc-preview__state-icon--error" aria-hidden="true"></i>
      <p class="doc-preview__state-title">Preview unavailable</p>
      <p class="doc-preview__state-subtitle">{{ errorMessage || 'This file could not be loaded for preview.' }}</p>
      <button type="button" class="doc-preview__fallback-btn" (click)="download()" [disabled]="!documentUrl || downloadInProgress">
        <i class="fa" [ngClass]="downloadInProgress ? 'fa-spinner fa-spin' : 'fa-download'" aria-hidden="true"></i> Download File
      </button>
    </div>

    <!-- PDF (native, or an office/rtf file successfully converted to PDF) -->
    <iframe *ngIf="showFrame"
            class="doc-preview__frame"
            [class.doc-preview__hidden]="loading"
            [src]="safeResourceUrl"
            (load)="onFrameLoad()"
            (error)="onFrameError()"
            title="Document preview">
    </iframe>

    <!-- Image -->
    <div class="doc-preview__image-wrap" *ngIf="kind === 'image' && !loadError" [class.doc-preview__hidden]="loading">
      <img class="doc-preview__image"
           [src]="documentUrl"
           [alt]="documentName"
           [style.transform]="'scale(' + zoomLevel + ')'"
           (load)="onFrameLoad()"
           (error)="onFrameError()" />
    </div>

    <!-- Audio -->
    <div class="doc-preview__media-wrap" *ngIf="kind === 'audio' && !loadError" [class.doc-preview__hidden]="loading">
      <i class="fa fa-file-audio-o doc-preview__media-icon" aria-hidden="true"></i>
      <audio class="doc-preview__audio" controls
             [src]="documentUrl"
             (loadedmetadata)="onFrameLoad()"
             (error)="onFrameError()">
      </audio>
    </div>

    <!-- Video -->
    <div class="doc-preview__media-wrap" *ngIf="kind === 'video' && !loadError" [class.doc-preview__hidden]="loading">
      <video class="doc-preview__video" controls
             [src]="documentUrl"
             (loadedmetadata)="onFrameLoad()"
             (error)="onFrameError()">
      </video>
    </div>

    <!-- Office/rtf/csv conversion failed, or a genuinely unsupported type -->
    <div class="doc-preview__state" *ngIf="showFallbackCard">
      <i class="fa doc-preview__state-icon" [ngClass]="headerIconClass" aria-hidden="true"></i>
      <p class="doc-preview__state-title">Preview unavailable</p>
      <p class="doc-preview__state-subtitle">This file type cannot be previewed directly.</p>
      <button type="button" class="doc-preview__fallback-btn" (click)="download()" [disabled]="!documentUrl || downloadInProgress">
        <i class="fa" [ngClass]="downloadInProgress ? 'fa-spinner fa-spin' : 'fa-download'" aria-hidden="true"></i> Download File
      </button>
    </div>

  </div>
</div>